// extracted by mini-css-extract-plugin
export default {"subNavText":"ConsumerDashboardMenu_subNavText__3W0Zc"};